/**
 * Created by neo on 07.05.21.
 */
import { makeAutoObservable } from 'mobx';

export type AudioEncoding = 'LINEAR16' | 'MP3' | 'OGG_OPUS';

export type GoogleTtsAudioConfig = {
  audioEncoding: AudioEncoding;
  pitch: number;
  speakingRate: number;
  volumeGainDb: number;
};

export function createGoogleTtsAudioConfig(json?: Partial<GoogleTtsAudioConfig>): GoogleTtsAudioConfig {
  return makeAutoObservable({
    audioEncoding: json?.audioEncoding ?? 'MP3',
    pitch: json?.pitch ?? -5.2,
    speakingRate: json?.speakingRate ?? 1.0,
    volumeGainDb: json?.volumeGainDb ?? 0.0,
  });
}
